import { observable } from "@legendapp/state";

/**
 * Marker for rows that originate from a board snapshot (read-only viewer)
 * rather than the org's live CRUD stream. CRUD wrappers consult this map
 * before issuing PUT/DELETE/CREATE so foreign-org rows are never echoed
 * back to the server, and `subscribe()` handlers drop Ably messages that
 * would conflict with a snapshot row.
 *
 * Keyed by the row's `id` field (block id, board id, dataset id, board
 * filter id) so a single map covers every store.
 */
export const snapshotOrigins$ = observable<Record<string, true>>({});

/** Returns `true` if `id` was hydrated from a board snapshot. */
export const isSnapshotOrigin = (id: string | undefined | null): boolean => {
  if (!id) return false;
  return snapshotOrigins$[id].peek() === true;
};

/** Tags a row id as snapshot-origin. Used by the hydrator. */
export const markSnapshotOrigin = (id: string): void => {
  snapshotOrigins$[id].set(true);
};

/**
 * Drops the snapshot tag for `id`. Used when leaving a read-only board so
 * subsequent writes (if the user somehow gains access) flow through sync
 * normally.
 */
export const clearSnapshotOrigin = (id: string): void => {
  snapshotOrigins$[id].delete();
};
